module.exports = __webpack_public_path__ + "img/post-4.dd823769.png";